import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../../../assets/orbis-logo.png'


const _hoisted_1 = { class: "dialogShell" }
const _hoisted_2 = { class: "login-alert login-error-message" }
const _hoisted_3 = { class: "form-container" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "switch-users"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_spinner = _resolveComponent("b-spinner")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form = _resolveComponent("b-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        class: _normalizeClass({'error-container': true,'hide-error': _ctx.state.errorMsg.length === 0, 'show-error': _ctx.state.errorMsg.length > 0})
      }, [
        _cache[2] || (_cache[2] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.state.errorMsg), 1)
      ], 2),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "alert-mask" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_b_form, {
          onSubmit: _withModifiers(_ctx.handleSubmit, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_b_form_input, {
                required: "",
                id: "username",
                ref: "username",
                disabled: _ctx.state.isDisabled || _ctx.reauth,
                onKeyup: _withKeys(_ctx.handleSubmit, ["enter"]),
                modelValue: _ctx.state.username,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.username) = $event)),
                modelModifiers: { trim: true },
                type: "text",
                class: "form-control",
                autofocus: !_ctx.reauth,
                label: "Username"
              }, null, 8, ["disabled", "onKeyup", "modelValue", "autofocus"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_b_form_input, {
                required: "",
                id: "password",
                ref: "password",
                disabled: _ctx.state.isDisabled,
                onKeyup: _withKeys(_ctx.handleSubmit, ["enter"]),
                modelValue: _ctx.state.password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.password) = $event)),
                modelModifiers: { trim: true },
                type: "password",
                class: "form-control",
                autofocus: _ctx.reauth,
                label: "Password"
              }, null, 8, ["disabled", "onKeyup", "modelValue", "autofocus"])
            ]),
            _createVNode(_component_b_button, {
              class: "btn-login",
              variant: "primary",
              onClick: _ctx.handleSubmit,
              disabled: _ctx.state.isDisabled
            }, {
              default: _withCtx(() => [
                (_ctx.state.isDisabled)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_b_spinner, { small: "" }),
                      _cache[3] || (_cache[3] = _createElementVNode("span", { style: {"margin-left":"10px"} }, "Logging In...", -1))
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.state.isDisabled)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Log In"))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["onClick", "disabled"])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ])
    ]),
    (_ctx.reauth)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_b_button, {
            variant: "link",
            style: {"float":"right"},
            onClick: _ctx.logout
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("Switch Users")
            ])),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true)
  ]))
}